import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthGuard } from './auth.guard';

@Injectable({
  providedIn: 'root'
})
export class ModeGuard implements CanActivate {

  constructor(private router: Router,private location: Location,private authGuard : AuthGuard) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    ): boolean {

    const currentUrl = document.baseURI

    if (currentUrl.includes('localhost')) {
      return true;
    } else {
      return false
      // this.router.navigate(['/']);
      // return this.authGuard.canActivate(next,state);
    }
  }
}